/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiIdentityAccountChangepasswordPut } from '../fn/account/api-identity-account-changepassword-put';
import { ApiIdentityAccountChangepasswordPut$Params } from '../fn/account/api-identity-account-changepassword-put';
import { apiIdentityAccountChangepasswordPut$Plain } from '../fn/account/api-identity-account-changepassword-put-plain';
import { ApiIdentityAccountChangepasswordPut$Plain$Params } from '../fn/account/api-identity-account-changepassword-put-plain';
import { Response } from '../models/response';

@Injectable({ providedIn: 'root' })
export class AccountService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiIdentityAccountChangepasswordPut()` */
  static readonly ApiIdentityAccountChangepasswordPutPath = '/api/identity/account/changepassword';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdentityAccountChangepasswordPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdentityAccountChangepasswordPut$Plain$Response(params?: ApiIdentityAccountChangepasswordPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiIdentityAccountChangepasswordPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdentityAccountChangepasswordPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdentityAccountChangepasswordPut$Plain(params?: ApiIdentityAccountChangepasswordPut$Plain$Params, context?: HttpContext): Observable<Response> {
    return this.apiIdentityAccountChangepasswordPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdentityAccountChangepasswordPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdentityAccountChangepasswordPut$Response(params?: ApiIdentityAccountChangepasswordPut$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiIdentityAccountChangepasswordPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdentityAccountChangepasswordPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdentityAccountChangepasswordPut(params?: ApiIdentityAccountChangepasswordPut$Params, context?: HttpContext): Observable<Response> {
    return this.apiIdentityAccountChangepasswordPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

}
